// extracted by mini-css-extract-plugin
module.exports = {"error":"ManualKPIEntryDashboard_error__3NrP1","notes":"ManualKPIEntryDashboard_notes__10QxP","gitPrimeMetricsTable":"ManualKPIEntryDashboard_gitPrimeMetricsTable__3uEAg"};